module.exports = __webpack_public_path__ + "static/media/teamMemberIconPrimary.471936ff.svg";